import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RestrictionZones } from '../models/RestrictionZones';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class RestrictionZoneService extends BaseApiService<RestrictionZones> {
  get cacheKey(): StorageKey {
    return StorageKey.contractServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/restrictionZones`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return RestrictionZones.unparse(obj);
  }

  protected parse(obj) {
    return RestrictionZones.parse(obj);
  }
}
